import { Injectable } from "@angular/core";
import { BasiqActions } from "./basiq.actions";
import { AccountView } from "../../../../models/view/account/account.view";
import { SyncStatusEnum } from "../../../../models/types/general-types";
import { CategoryView } from "../../../../models/view/category/category.view";
import { BasiqIoTransactionType } from "@bitwarden/web-vault/app/models/types/basiq-io-transaction.types";
import { DEFAULT_CATEGORY_NAME } from "@bitwarden/web-vault/app/models/constants/category.constants";

@Injectable({ providedIn: "root" })
export class BasiqCategoryAction extends BasiqActions {
  syncStatus: SyncStatusEnum;

  async saveCategories(categories: CategoryView[], account: AccountView) {
    try {
      if (categories?.length) {
        const processMessage = `Saving Categories from Transactions of ${account.name}`;
        this.appState.startProcess("importing-data", processMessage);
        const isSaved = await this.userStore.categories.saveToVault(categories, true);
        if (!isSaved) {
          const error = new Error("Could not save categories into vault");
          await this.glossSyncService.logError(
            [account],
            error,
            "Saving Categories",
            SyncStatusEnum.cantSaveCategories,
          );
          this.syncStatus = SyncStatusEnum.cantSaveCategories;
        }
        this.appState.endProcess("importing-data");
        return isSaved;
      }
      return true;
    } catch (error) {
      await this.glossSyncService.logError(
        [account],
        error,
        "Saving Categories",
        SyncStatusEnum.cantSaveCategories,
      );
      this.syncStatus = SyncStatusEnum.cantSaveCategories;
      this.appState.endProcess("importing-data");
      return false;
    }
  }

  /* Returns an aray of category names to be used as a base for creating categories */
  categoryNamesFromBasiqTransaction(rawBasiqIoTransaction: BasiqIoTransactionType): string[] {
    const basiqCategory = rawBasiqIoTransaction.enrich?.category;
    /* If basiq transaction has no enriched category, return empty array */
    if (!basiqCategory) {
      return [];
    }

    // Fallback to MCC(Merchant Category Code) description if ANZSIC not found
    if (basiqCategory.mcc?.title) {
      return [basiqCategory.mcc.title];
    }

    /* Look for ANZSIC category first, that is the most specific */
    const anzsic = basiqCategory.anzsic;
    if (anzsic) {
      // Prioritize deepest/most-specific available title
      const cat =
        anzsic.class?.title ||
        anzsic.group?.title ||
        anzsic.subdivision?.title ||
        anzsic.division?.title;
      if (cat) {
        return [cat];
      }
    }

    /* Worst case scenario  return empty array */
    return [];
  }
  categoryViewByName(catName: string): CategoryView {
    try {
      const categories = this.userStore.categories.categoryViews();
      return categories.find((cat) => cat.name.toLowerCase() === catName.toLowerCase());
    } catch (e) {
      this.testLogService.testLog(e);
    }
  }

  /**TODO implement a mapper or maybe a better way to map transactions' data to proper categories*/
  getMappedCategoryName(categoryName: string) {
    if (categoryName === "Unknown") {
      return DEFAULT_CATEGORY_NAME;
    }

    return categoryName;
  }
}
